/**
 * API base URL
 * - dacă REACT_APP_API_BASE e setat explicit la build time -> folosim asta (CI prod/staging)
 * - dacă suntem pe localhost: folosim valoarea din env sau localhost backend
 * - dacă hostname-ul contine "staging" -> staging-api
 * - altfel: producție
 */
export function getApiBaseUrl() {
  const apiBase = process.env.REACT_APP_API_BASE;

  // CI build cu valoare explicită
  if (apiBase && apiBase.startsWith('http')) {
    return apiBase;
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname;
    if (host.includes('localhost') || host.includes('127.0.0.1')) {
      return apiBase || 'http://localhost:3000';
    }
    if (host.includes('staging')) {
      return 'https://staging-api.nativus.ro';
    }
  }

  return 'https://api.nativus.ro';
}
